import { Stack, Typography } from '@mui/material';
import InfoModal from 'components/Common/InfoModal';
import CreateStaffForm from 'components/Staff/CreateStaffForm';
import { tenantName } from 'config/apiConfig';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { inviteNewMember } from 'redux/slices/community/parishMemberSlice';
import { AppDispatch, RootState } from 'redux/store';
import { InviteNewMemberPayload, SendEmailPayload } from 'types/community';
import { InviteMemberProps } from 'types/modal';

const InviteMemberModal = ({ isOpen, onClose }: InviteMemberProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const [loading, setLoading] = useState<boolean>(false);
    const { username = '', email = '' } = useSelector((state: RootState) => ({
        username: state.user.userInfo?.username,
        email: state.user.userInfo?.email,
    }));

    const onSubmit = async (formValues: InviteNewMemberPayload) => {
        const data: SendEmailPayload = {
            valid: true,
            templateId: 'email.template.body',
            recipients: [formValues.email],
            tenantName: tenantName,
            title: 'You are invited to join Catholic Community!',
            subject: 'You have been invited.',
            parameters: [
                {
                    key: '$primaryColor',
                    value: 'FFFFFF',
                },
                {
                    key: '$secondaryColor',
                    value: 'DDDDDD',
                },
                {
                    key: '$logoUrl',
                    value: 'logoUrl',
                },
                {
                    key: '$userName',
                    value: username,
                },
                {
                    key: '$eventName',
                    value: 'Welcome to Catholic',
                },
                {
                    key: '$email',
                    value: formValues.email,
                },
                {
                    key: '$iosAppLink',
                    value: 'https://www.apple.com/',
                },
                {
                    key: '$iosDownloadAppImage',
                    value: 'ios_url2',
                },
                {
                    key: '$androidAppLink',
                    value: 'https://www.google.com/',
                },
                {
                    key: '$androidDownloadAppImage',
                    value: 'android_url2',
                },
            ],
        };
        try {
            setLoading(true);
            const { payload } = await dispatch(inviteNewMember(data));
            setLoading(false);
            if (payload?.code === 200) {
                onClose();
            }
        } catch (error) {
            setLoading(false);
        }
    };
    return (
        <>
            <InfoModal title="invite New Member" isOpen={isOpen} onClose={onClose} hideActionButtons>
                <Stack gap={2}>
                    <Typography>
                        Please fill in the information for the new member below. Once you have provided the necessary information we will
                        send an invitation to their email.
                    </Typography>
                    <CreateStaffForm submitButtonText="Send Invite" loading={loading} onSubmit={onSubmit} />
                </Stack>
            </InfoModal>
        </>
    );
};

export default InviteMemberModal;
